import gql from 'graphql-tag'

import { clickAndCollect } from './fragments'

export default gql`
mutation updateCCRoute($id: ID, $fields: CCRouteInput) {
	cashAssist {
		updateCCRoute(id: $id, fields: $fields) {
			...clickAndCollect
		}
	}
}
${clickAndCollect}
`
